import cc from 'currency-codes';
import Vue from 'vue';

Vue.prototype.$currencyCodes = cc;
